"use client";

import { useClientConfig } from "@providers/app-provider/client-app-provider";
import { Button, Card, CardContent } from "@saridana-core/react-ui-kit";
import { TProductContactSection } from "@shared/types";
import { DynamicForm, SectionHeading } from "@shared/ui";
import Image from "next/image";

function ContactForm({ formFields, footnote, buttonText, submitType, formDefaultValue }: TProductContactSection) {
  const config = useClientConfig();
  const whatsappManager = config?.layoutSettings?.attributes?.features?.whatsappManager;

  const handleSubmit = (values: any) => {
    if (values) {
      switch (submitType) {
        case "whatsapp":
          let whatsappMessage = `Halo BPR Saridana,%0A%0ASaya ingin mengajukan pertanyaan melalui formulir kontak.%0A%0ANama: ${encodeURIComponent(values.name)}%0ANomor Telepon: ${encodeURIComponent(values.phone)}`;

          if (values.type) {
            whatsappMessage += `%0A%0ATipe Pinjaman: ${encodeURIComponent(values.type)}`;
          }

          if (values.company) {
            whatsappMessage += `%0A%0ANama Perusahaan: ${encodeURIComponent(values.company)}`;
          }

          whatsappMessage += `%0A%0ATerima Kasih.`;

          window.open(`${whatsappManager?.link}?text=${whatsappMessage}`, "_blank", "noopener,noreferrer");
          break;
      }
    }
  };

  return (
    <Card className="w-full rounded-lg">
      <CardContent className="h-auto px-6 py-6 md:px-9 md:py-10">
        <div>
          <DynamicForm
            fields={formFields}
            defaultValues={
              formDefaultValue ||
              formFields.reduce((obj: any, item) => {
                obj[item.name] = "";
                return obj;
              }, {})
            }
            onSubmit={handleSubmit}
          >
            <Button type="submit" className="text-lg md:text-xl h-14 md:h-[60px] md:px-8 w-full rounded-xl py-4 px-6 font-bold">
              {buttonText}
            </Button>
          </DynamicForm>
        </div>

        {footnote && <div className="text-md leading-[150%] text-gray-500 mt-3">{footnote}</div>}
      </CardContent>
    </Card>
  );
}

export function ProductContactSection(props: TProductContactSection) {
  return (
    <section className="relative overflow-hidden" style={{ background: "linear-gradient(105.73deg, #1DB0DE 3.41%, #265E78 85.1%)" }}>
      {props?.background?.data?.attributes?.url && (
        <Image
          src={props?.background?.data?.attributes?.url}
          height={props?.background?.data?.attributes?.height}
          width={props?.background?.data?.attributes?.width}
          alt={
            props?.background?.data?.attributes?.alternativeText || props?.background?.data?.attributes?.name || "Product Contact Section"
          }
          className="h-[70%] md:h-auto xl:h-[110%] w-full md:w-[65%] xl:w-[75%] object-cover bottom-0 right-0 absolute z-1 object-right md:object-left-top lg:object-left"
        />
      )}

      <div className="py-20 sm:py-28 container relative">
        <div className="flex gap-10 xl:gap-[100px] w-full flex-col lg:flex-row lg:items-center">
          <div className="lg:w-[50%] lg:min-w-[50%] text-white">
            <SectionHeading
              title={props?.title}
              description={props?.description}
              descriptionClassName="mx-auto lg:mx-0 lg:w-[80%] lg:min-w-[80%]"
            />
          </div>

          <div>
            <ContactForm {...props} />
          </div>
        </div>
      </div>
    </section>
  );
}
